import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import { SiteConfigManager, StorageManager } from '@atlas/core';
import { Button } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';
import StaticBlock from 'common/StaticBlock/StaticBlock';

export const DemoPopup = () => {
  const enableDemoPopup = SiteConfigManager.getConfig(
    'config.config.general.enableDemoPopup',
    false,
  );

  const demoPopupStaticBlock = SiteConfigManager.getConfig(
    'config.config.general.demoPopupStaticBlock',
    '',
  );

  const demoPopupAcceptedKey = 'demoPopupAcceptedKey';

  const [demoPopupAccepted, setIsDemoPopupAccepted] = useState(
    StorageManager.getItem(demoPopupAcceptedKey) === 'true',
  );

  const contentRef = useRef(null);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const contentNode = contentRef.current;
    if (!contentNode) return;

    const observer = new MutationObserver(() => {
      const contentHeight = contentNode.clientHeight;
      const containerHeight = contentNode.parentNode.clientHeight;

      setShowShadow(contentHeight > containerHeight);
    });

    observer.observe(contentNode, { attributes: true, childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem('pageReloaded')) {
      StorageManager.removeItem(demoPopupAcceptedKey);
      setIsDemoPopupAccepted(false);
    }
  }, []);

  const onClickDemoPopup = () => {
    StorageManager.setItem(demoPopupAcceptedKey, 'true');
    sessionStorage.setItem('pageReloaded', 'true');
    setIsDemoPopupAccepted(true);
  };

  const footerClassName = cx('demo-popup-footer', { 'show-shadow': showShadow });

  if (enableDemoPopup && demoPopupStaticBlock && !demoPopupAccepted) {
    return (
      <ModalPortal>
        <div className="demo-popup">
          <div className="demo-popup-content" ref={contentRef}>
            <StaticBlock
              options={{
                source: SiteConfigManager.getConfig('config.config.general.demoPopupStaticBlock'),
              }}
            />
          </div>
          <div className={footerClassName}>
            <Button label="Ok" onClick={onClickDemoPopup} />
          </div>
        </div>
      </ModalPortal>
    );
  }

  return null;
};
